module.exports = __webpack_public_path__ + "static/img/hysteroscope-3.35e591c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-3.jpg
// module id = bliy
// module chunks = 52